import React from 'react';

const Img = (props) => {
    const { alt = "HRTPS", ...other } = props;
    return <img alt={alt} {...other} />
}
export default Img;